import React, { useState } from 'react';

import { useParams } from 'react-router';

import ContentCard from '../../components/ContentCard';
import PageContent from '../../components/PageContent';
import { NoContentMessage } from '../../components/PageLayout';
import SkeletonStack from '../../components/SkeletonStack';
import {
  useGetClassQuery,
} from '../../services/classes';
import { Lesson } from '../../services/classes/types';
import { getClassId, getClassName } from '../../utils/common/classes';

import ClassLessonDetails from './ClassLessonDetails';
import DetailsTab from './DetailsTab';
import { PageContainer } from './index.styles';

const TeacherClassPage = () => {
  const { subject, classId } = useParams();

  if (!subject || !classId) {
    return <NoContentMessage />;
  }

  const { data: classObj, isLoading: isClassLoading } = useGetClassQuery({
    subject, classId,
  });
  const [selectedLesson, setSelectedLesson] = useState<Lesson | undefined>();

  const deselectLesson = () => {
    setSelectedLesson(undefined);
  };

  if (isClassLoading) {
    return <SkeletonStack />;
  }

  if (!classObj) {
    return <NoContentMessage />;
  }

  return (
    <PageContent
      sideBar={selectedLesson ? (
        <ClassLessonDetails
          selectedLesson={selectedLesson}
          onClose={() => deselectLesson()}
        />
      ) : <div />}
      sideBarOpen={!!selectedLesson}
      sideBarWidth={600}
    >
      <PageContainer>
        <ContentCard
          variant="transparent"
          backButtonHref={-1}
          title={
            `Class Details (${getClassName(getClassId(classObj?.data.id) ?? '', classObj?.data.course ?? '')})`
          }
          titleVariant="h5"
          padding="none"
          maxWidth={720}
        >
          <DetailsTab
            classObj={classObj.data}
            metadata={classObj.metadata}
            setSelectedLesson={setSelectedLesson}
            selectedLesson={selectedLesson}
          />
        </ContentCard>
      </PageContainer>
    </PageContent>
  );
};
export default TeacherClassPage;
